<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
    <title>hospital</title>
    <path
      d="M4.31176 0.831299V9.10333H2.47951C1.417 9.10333 0.555664 9.96466 0.555664 11.0272V19.9117H7.18625V17.9878H2.47951V11.0272H6.22433V9.32664H6.2356V2.75514H15.0224L15.0221 11.0272H18.7669V17.9878H14.0601V19.9117H20.6907V11.0272C20.6907 9.96466 19.8294 9.10333 18.7669 9.10333H16.9462V0.831299H4.31176Z"
    />
    <path
      d="M11.5854 5.83817C11.5854 5.30692 11.1547 4.87625 10.6234 4.87625C10.0922 4.87625 9.66151 5.30692 9.66151 5.83817V6.8001H8.69959C8.16833 6.8001 7.73767 7.23076 7.73767 7.76202C7.73767 8.29327 8.16833 8.72394 8.69959 8.72394H9.66151V9.68586C9.66151 10.2171 10.0922 10.6478 10.6234 10.6478C11.1547 10.6478 11.5854 10.2171 11.5854 9.68586V8.72394H12.5473C13.0785 8.72394 13.5092 8.29327 13.5092 7.76202C13.5092 7.23076 13.0785 6.8001 12.5473 6.8001H11.5854V5.83817Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.19189 12.6431H14.0543V19.9119H7.19189V12.6431ZM9.11573 14.567H12.1305V17.9881H9.11573V14.567Z"
    />
  </svg>
</template>
